import { render } from "./TheaterPlayer.vue?vue&type=template&id=7a532df0&scoped=true"
import script from "./TheaterPlayer.vue?vue&type=script&lang=ts"
export * from "./TheaterPlayer.vue?vue&type=script&lang=ts"

import "./TheaterPlayer.vue?vue&type=style&index=0&id=7a532df0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7a532df0"

export default script